import { Grid, Skeleton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { FC } from 'react';

import { ContactsDisplayMode } from '../../hooks/use-contacts-variant';

const useStyles = makeStyles((theme: any) => ({
  row: { '& + &': { marginTop: theme.spacing(0.5) } },
}));

type ResultsSkeletonProps = {
  displayMode: ContactsDisplayMode;
  count?: number;
};

// First-load placeholder in the shape of the active results view.
const ResultsSkeleton: FC<ResultsSkeletonProps> = ({ displayMode, count = 6 }) => {
  const classes = useStyles();
  const items = Array.from(Array(count).keys());

  if (displayMode === 'list') {
    return (
      <div aria-hidden>
        {items.map((i) => (
          <Skeleton key={i} variant="rectangular" height={40} className={classes.row} />
        ))}
      </div>
    );
  }

  return (
    <Grid container spacing={2} aria-hidden>
      {items.map((i) => (
        <Grid key={i} item xs={12} sm={6} lg={4}>
          <Skeleton variant="rectangular" height={128} />
        </Grid>
      ))}
    </Grid>
  );
};

export default ResultsSkeleton;
